export default __webpack_public_path__ + "static/media/640_dummy2016-grafikdesigner01-mobile-de.930a9f66.png";